<template>
  <div class="accordeon">
    <div
      class="accordeon__head"
      :class="isOpen ? 'accordeon__head--opened' : ''"
      @click="toggleShow"
    >
      <div class="accordeon__title">
        <slot name="title"> </slot>
      </div>
      <div class="accordeon__icon">
        <div class="icon i-accordeon-plus"></div>
      </div>
    </div>
    <ExpandTransition duration="250">
      <div v-if="isOpen" class="accordeon__content">
        <slot name="content"> </slot>
      </div>
    </ExpandTransition>
  </div>
</template>

<script>
import ExpandTransition from "@/components/shared/transitions/ExpandTransition.vue";

export default {
  components: {
    ExpandTransition,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleShow() {
      this.$emit("update:isActive", !this.isOpen);
      this.$emit("opened");
    },
  },
  watch: {
    isActive: {
      immediate: true,
      handler(val) {
        this.isOpen = val;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.accordeon {
  text-align: left;
  background: white;
  border-bottom: 1px solid #ddd;

  &__head {
    padding: 20px 15px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4a4a4a;

    .icon {
      margin-left: auto;
      width: 10px;
      transition: transform 0.2s ease-out;
      height: 10px;
    }

    &--opened {
      .icon {
        transform: rotate(45deg);
      }
    }
  }

  &__content {
    display: block;
    overflow: hidden;
  }
}
</style>
